import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import './i18n';
import { registerSW } from 'virtual:pwa-register';
import { Toaster } from 'react-hot-toast';
import { limitDateYears } from './utils/limitDateYears';

// Cap the year of every date field at four digits
limitDateYears();

// Register service worker for PWA
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster position="top-right" />
      <App />
    </Provider>
  </React.StrictMode>
);
